<template>
  <ProjectMilestoneList :project="project"/>
</template>

<script>
import ProjectMilestoneList from '../../../../components/Relations/ProjectMilestones/Panels/List'

export default {
  components: {ProjectMilestoneList},

  model: {
    prop: 'project'
  },

  props: {
    project: {
      required: true,
      type: Object
    }
  }
}
</script>
